import { POSSourceDTO } from '@services/DTO/pos/POSSourceDTO'
import { POSTableMappingItemDTO } from '@services/DTO/pos/POSTableMappingItemDTO'

export class POSConfigurationDTO {
    constructor(
        public id: string,
        public isEnabled: boolean,
        public source: POSSourceDTO,
        public apiBaseUrl: string,
        public databaseName: string,
        public username: string,
        public posUserId: string,
        public password: string | null,
        public tableMappings: POSTableMappingItemDTO[] | null,
        public onlyPushDepositBookings: boolean = false
    ) {
    }
}
